// extracted by mini-css-extract-plugin
export default {"p":"Fellowship_p__oYvWQ","h1":"Fellowship_h1__PzICt","h3":"Fellowship_h3__yldqH"};